export default __webpack_public_path__ + "static/ambient-ai-68ef8e5d6e01125c7a2a805cd19f881b.png";